import React from "react";

const PinterestPrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-gray-200">
      <h1 className="text-3xl font-bold mb-4 text-white">PRIVACY POLICY</h1>
      <h2 className="text-2xl font-semibold mb-6 text-gray-300">
        Project Inika Pinterest Integration
      </h2>

      <p className="mb-4 text-gray-400">
        <strong>Last Updated: February 20, 2025</strong>
      </p>

      {/* Converting the HTML content to JSX with consistent styling */}
      <div className="space-y-8">
        <div className="section">
          <h2 className="text-2xl font-semibold mb-4 text-white">
            Interpretation and Definitions
          </h2>
          <h3 className="text-xl font-semibold mb-3 text-gray-300">
            Interpretation
          </h3>
          <p className="mb-4">
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </p>
        </div>

        <div className="section">
          <h3 className="text-xl font-semibold mb-3 text-white">Definitions</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-300">
            <li>
              <strong>Account:</strong> means a unique account created for You
              to access our Service or parts of our Service.
            </li>
            <li>
              <strong>Affiliate:</strong> means an entity that controls, is
              controlled by or is under common control with a party...
            </li>
            {/* Continue with other definitions... */}
          </ul>
        </div>

        <div className="section">
          <h2 className="text-2xl font-semibold mb-4 text-white">
            Collecting and Using Your Personal Data
          </h2>
          <h3 className="text-xl font-semibold mb-3 text-gray-300">
            Types of Data Collected
          </h3>

          <h4 className="text-lg font-medium mb-2 text-gray-300">
            Personal Data
          </h4>
          <p className="mb-4">
            While using Our Service, We may ask You to provide Us with certain
            personally identifiable information that can be used to contact or
            identify You. Personally identifiable information may include, but
            is not limited to:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-300">
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Usage Data</li>
          </ul>
        </div>

        <div className="section">
          <h4 className="text-lg font-medium mb-2 text-gray-300">Usage Data</h4>
          <p className="mb-4">
            Usage Data is collected automatically when using the Service.
          </p>
          <p className="mb-4">
            Usage Data may include information such as Your Device's Internet
            Protocol address (e.g. IP address), browser type, browser version,
            the pages of our Service that You visit, the time and date of Your
            visit, the time spent on those pages, unique device identifiers and
            other diagnostic data.
          </p>
          <p className="mb-4">
            When You access the Service by or through a mobile device, We may
            collect certain information automatically, including, but not
            limited to, the type of mobile device You use, Your mobile device
            unique ID, the IP address of Your mobile device, Your mobile
            operating system, the type of mobile Internet browser You use,
            unique device identifiers and other diagnostic data.
          </p>
        </div>

        <div className="section">
          <h4 className="text-lg font-medium mb-2 text-gray-300">
            Information from Third-Party Social Media Services
          </h4>
          <p className="mb-4">
            The Company allows You to create an account and log in to use the
            Service through the following Third-party Social Media Services:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-300">
            <li>Google</li>
            <li>Facebook</li>
            <li>Instagram</li>
            <li>Twitter</li>
            <li>LinkedIn</li>
          </ul>
        </div>

        <div className="section">
          <h3 className="text-xl font-semibold mb-4 text-white">
            Use of Your Personal Data
          </h3>
          <p className="mb-4">
            The Company may use Personal Data for the following purposes:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-300">
            <li>
              <strong>To provide and maintain our Service</strong>, including to
              monitor the usage of our Service.
            </li>
            <li>
              <strong>To manage Your Account:</strong> to manage Your
              registration as a user of the Service.
            </li>
            <li>
              <strong>For business transfers:</strong> We may use Your
              information to evaluate or conduct a merger, divestiture,
              restructuring, reorganization, dissolution, or other sale or
              transfer of some or all of Our assets.
            </li>
            <li>
              <strong>To manage Your requests:</strong> To attend and manage
              Your requests to Us.
            </li>
          </ul>
        </div>

        <div className="section">
          <h3 className="text-xl font-semibold mb-4 text-white">
            Retention of Your Personal Data
          </h3>
          <p className="mb-4">
            The Company will retain Your Personal Data only for as long as is
            necessary for the purposes set out in this Privacy Policy. We will
            retain and use Your Personal Data to the extent necessary to comply
            with our legal obligations, resolve disputes, and enforce our legal
            agreements and policies.
          </p>
        </div>

        <div className="section">
          <h3 className="text-xl font-semibold mb-4 text-white">
            Transfer of Your Personal Data
          </h3>
          <p className="mb-4">
            Your information, including Personal Data, is processed at the
            Company's operating offices and in any other places where the
            parties involved in the processing are located.
          </p>
          <p className="mb-4">
            Your consent to this Privacy Policy followed by Your submission of
            such information represents Your agreement to that transfer.
          </p>
        </div>

        <div className="section">
          <h3 className="text-xl font-semibold mb-4 text-white">
            Security of Your Personal Data
          </h3>
          <p className="mb-4">
            The security of Your Personal Data is important to Us, but remember
            that no method of transmission over the Internet, or method of
            electronic storage is 100% secure. While We strive to use
            commercially acceptable means to protect Your Personal Data, We
            cannot guarantee its absolute security.
          </p>
        </div>

        <div className="section">
          <h3 className="text-xl font-semibold mb-4 text-white">
            Children's Privacy
          </h3>
          <p className="mb-4">
            Our Service does not address anyone under the age of 13. We do not
            knowingly collect personally identifiable information from anyone
            under the age of 13.
          </p>
        </div>

        <div className="section">
          <h3 className="text-xl font-semibold mb-4 text-white">
            Links to Other Websites
          </h3>
          <p className="mb-4">
            Our Service may contain links to other websites that are not
            operated by Us. If You click on a third party link, You will be
            directed to that third party's site. We strongly advise You to
            review the Privacy Policy of every site You visit.
          </p>
        </div>

        <div className="section">
          <h3 className="text-xl font-semibold mb-4 text-white">
            Changes to this Privacy Policy
          </h3>
          <p className="mb-4">
            We may update Our Privacy Policy from time to time. We will notify
            You of any changes by posting the new Privacy Policy on this page.
          </p>
          <p className="mb-4">
            We will let You know via email and/or a prominent notice on Our
            Service, prior to the change becoming effective and update the "Last
            updated" date at the top of this Privacy Policy.
          </p>
        </div>

        <div className="mt-8 border-t border-gray-700 pt-8">
          <h3 className="text-xl font-semibold mb-4 text-white">Contact Us</h3>
          <p className="mb-4">
            If you have any questions about this Privacy Policy, You can contact
            us:
          </p>
          <address className="text-gray-300 not-italic">
            Project Inika
            <br />
            823 Congress Ave, Austin, TX 78701, Suite for Industrious c/o
            Project Inika
            <br />
            ykothari@inika.app
          </address>
        </div>
      </div>
    </div>
  );
};

export default PinterestPrivacyPolicy;
